export default function Articles() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-5xl font-bold text-gray-900 mb-6">Articles</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-600 leading-relaxed mb-6">
            Welcome to our articles page. We're dedicated to providing you with 
            the best experience and information.
          </p>
          
          <div className="grid md:grid-cols-2 gap-8 mt-12">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Learn More</h3>
              <p className="text-gray-600">Discover what makes us unique and how we can help you achieve your goals.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Get in Touch</h3>
              <p className="text-gray-600">Ready to get started? Contact us today to learn more about our services.</p>
            </div>
          </div>
        </div>

    </div>
  );
}
